import React from "react";
import FadeInOnView from "../../../../components/FadeInOnView";
import { sectionFiveCards } from "../../data";
import {
  SectionFive,
  SectionFiveInner,
  SectionFiveMobileIntro,
  SectionFiveTitle,
  SectionFiveMobileTitle,
  SectionFiveFrame,
  SectionFiveOutline,
  SectionFiveCards,
  SectionFiveCard,
  SectionFiveButtons,
  SectionFiveButton
} from "./styles";

export default function SectionFiveComponent({ onOpenDifferences, onOpenFaq }) {
  return (
    <SectionFive>
          <SectionFiveInner>
            <SectionFiveMobileIntro>
              <strong>A TRATAZ</strong> CONECTA SEU ATENDIMENTO À ROTINA DO
              PACIENTE.
            </SectionFiveMobileIntro>

            <FadeInOnView>
              <SectionFiveTitle>
                <strong>CRIE</strong> SEU CONTEÚDO, <strong>DESENVOLVA</strong>{" "}
                SEU PROTOCOLO ACOMPANHE A EVOLUÇÃO{" "}
                <strong>DO TRATAMENTO</strong>
              </SectionFiveTitle>
            </FadeInOnView>

            <SectionFiveFrame>
              <SectionFiveOutline />
              <SectionFiveCards>
                {sectionFiveCards.map((src, index) => (
                  <FadeInOnView key={src} delay={120 + index * 90}>
                    <SectionFiveCard
                      src={src}
                      alt={`Conteúdo da Trataz ${index + 1}`}
                    />
                  </FadeInOnView>
                ))}
              </SectionFiveCards>

              <SectionFiveMobileTitle>
                <strong>CRIE</strong> SEU CONTEÚDO, <strong>DESENVOLVA</strong>{" "}
                SEU PROTOCOLO ACOMPANHE A EVOLUÇÃO{" "}
                <strong>DO TRATAMENTO</strong>
              </SectionFiveMobileTitle>

              <SectionFiveButtons
                as={FadeInOnView}
                delay={520}
              >
                <SectionFiveButton type="button" onClick={onOpenDifferences}>
                  DIFERENCIAIS
                </SectionFiveButton>
                <SectionFiveButton type="button" onClick={onOpenFaq}>
                  PERGUNTAS FREQUENTES
                </SectionFiveButton>
              </SectionFiveButtons>
            </SectionFiveFrame>
          </SectionFiveInner>
        </SectionFive>
  );
}
